module.exports = __webpack_public_path__ + "static/media/2.bd6c9bf0.png";